export default function(initialState, reducerMap) {
    return (state = initialState, action) => {
        //console.log("ACTION", action, state);
        const reducer = reducerMap[action.type];
        return reducer ? reducer(state, action.payload) : state;
    }
}


// WEBPACK FOOTER //
// ./src/client/src/utils/createreducer.js